import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const EditProfileIcon = _ref => {
  let {
      size = "12",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M0 9.56905V12.069H2.5L9.87333 4.69572L7.37333 2.19572L0 9.56905ZM11.8067 2.76238C12.0667 2.50238 12.0667 2.08238 11.8067 1.82238L10.2467 0.262383C9.98667 0.00238281 9.56667 0.00238281 9.30667 0.262383L8.08667 1.48238L10.5867 3.98238L11.8067 2.76238Z",
    fill: color
  }));
};
export default EditProfileIcon;